const INTERNAL_REQUEST_LIST_FILTER_KEYS = [ 'code', 'status', 'request_by' ]

const normalizeStatusValues = (searchParams) => (
  searchParams
    .getAll('status')
    .flatMap((value) => value.split(','))
    .map((value) => value.trim())
    .filter(Boolean)
)

export const getInternalRequestListUrlState = (search = '') => {
  const searchParams = new URLSearchParams(search)
  const page = Math.max(Number(searchParams.get('page') || 1), 1)
  const pageSize = Math.max(Number(searchParams.get('per_page') || 10), 1)
  const statusValues = normalizeStatusValues(searchParams)
  const filters = []

  if (searchParams.get('code')) {
    filters.push({ id: 'code', value: searchParams.get('code') })
  }

  if (searchParams.get('request_by')) {
    filters.push({ id: 'request_by', value: searchParams.get('request_by') })
  }

  if (statusValues.length > 0) {
    filters.push({ id: 'status', value: statusValues })
  }

  return {
    pageIndex : page - 1,
    pageSize,
    filters
  }
}

export const syncInternalRequestListUrl = ({ history, pathname, currentSearch, tableState }) => {
  const searchParams = new URLSearchParams(currentSearch)
  const filters = tableState?.filters || []
  const pageIndex = Number.isInteger(tableState?.pageIndex) ? tableState.pageIndex : 0
  const pageSize = Number.isInteger(tableState?.pageSize) ? tableState.pageSize : 10

  INTERNAL_REQUEST_LIST_FILTER_KEYS.forEach((filterKey) => searchParams.delete(filterKey))

  filters.forEach((filter) => {
    if (!INTERNAL_REQUEST_LIST_FILTER_KEYS.includes(filter.id)) return

    if (filter.id === 'status') {
      Array(filter.value).flat().filter(Boolean).forEach((status) => searchParams.append('status', status))
      return
    }

    if (filter.value) searchParams.set(filter.id, filter.value)
  })

  searchParams.set('page', String(pageIndex + 1))
  searchParams.set('per_page', String(pageSize))

  const nextSearch = searchParams.toString()
  const currentNormalizedSearch = currentSearch.toString().replace(/^\?/, '')

  if (nextSearch === currentNormalizedSearch) return

  history.replace({
    pathname,
    search: nextSearch ? `?${nextSearch}` : ''
  })
}
